import { Phone } from "lucide-react";
import { PRACTICE } from "@/data/practice";

export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${PRACTICE.phoneRaw}`}
      data-testid="sticky-call-button"
      className="md:hidden fixed bottom-5 inset-x-5 z-50 flex items-center justify-center gap-2.5 rounded-full bg-[#3F9E8E] text-white font-semibold text-base px-6 py-4 shadow-[0_10px_30px_rgb(63,158,142,0.4)] active:scale-[0.98] transition-transform duration-150"
      aria-label={`Appeler le cabinet au ${PRACTICE.phone}`}
    >
      <Phone className="w-5 h-5" strokeWidth={2} />
      Appeler le cabinet
    </a>
  );
};
